import MercadoPagoLinkButton from './MercadoPagoLinkButton';
import './PaymentLinkButton.css';

/**
 * External payment link button: Mercado Pago links keep their branded button;
 * Clip links (https://pago.clip.mx/…) get Clip's orange. No Clip logo asset —
 * text only.
 */
const PaymentLinkButton = ({ href, provider, onClick, children, style }) => {
  if (provider !== 'clip') {
    return <MercadoPagoLinkButton href={href} onClick={onClick} style={style}>{children}</MercadoPagoLinkButton>;
  }
  return (
    <a
      className="btn clip-link-button"
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      onClick={onClick}
      style={style}
    >
      {children}
    </a>
  );
};

export default PaymentLinkButton;
